import {Component} from "@angular/core";

@Component({
    selector: "fui-tags",
    styleUrls: ["./tags.component.scss"],
    templateUrl: "./tags.component.html",
    standalone: false
})
export class FUITagsComponent {
    constructor() {

    }
}
